import React, { useState } from "react";
import PopupBackground from "@component/PopupBackground";
import { fetchBatchCreateOrderFee } from "@redux/externalOrderSlice";
import { Button, Form, Input, Row, Select } from "antd";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";

const { Option } = Select;

const Dash = styled.div`
  padding: 0 5px;
  margin-top: -25px;
`;

const Wrapper = styled.div`
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  background: ${({ theme }) => theme.colorNeutral100};
  border-radius: 2px;
  width: 620px;
  padding: 23px 14px 20px 20px;

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    order: 1;
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
    margin: 0;
  }
`;
const CustomButton = styled(Button)`
  margin-right: 10px;
`;
const RowTitle = styled.div<{ bold?: boolean }>`
  align-self: flex-start;
  width: 100px;
  line-height: 32px;
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? "bold" : "normal")};
`;
const RowContent = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  display: flex;
  align-items: center;
`;
const RequiredIcon = styled.span`
  color: red;
`;
const Percent = styled.div`
  margin-left: 24px;
  margin-bottom: 24px;
`;

type Props = {
  onClose: () => void;
};

interface FormState {
  name: string;
  nameOption?: string;
  rate: string;
  amount: string;
}

export default function CreateOrderFeePopup(props: Props) {
  const { onClose } = props;

  const dispatch = useDispatch();

  const { externalOrderId } = useParams();

  const [form] = Form.useForm();
  const [warningText, setWarningText] = useState<string | undefined>();

  const onSubmit = (values: FormState) => {
    const payload = {
      name: values.nameOption ? `${values.name}-${values.nameOption}` : values.name,
      rate: values.rate ? Number(values.rate) : undefined,
      amount: values.amount ? Number(values.amount) : undefined,
    };
    if (!values.rate && !values.amount) {
      setWarningText("項目比例或項目金額(TWD)必填其中一項 ");
      return;
    }

    dispatch(fetchBatchCreateOrderFee([{ ...payload, externalOrder: parseInt(externalOrderId, 10) }]));
    onClose();
  };

  return (
    <PopupBackground close={onClose} fixed>
      <Wrapper>
        <Form colon={false} labelAlign="left" labelCol={{ span: 4 }} form={form} initialValues={{}} onFinish={onSubmit}>
          <Row wrap={false}>
            <RowTitle>
              項目名稱
              <RequiredIcon>*</RequiredIcon>
            </RowTitle>
            <RowContent width={400}>
              <Form.Item name="name" rules={[{ required: true, message: "" }]}>
                <Select style={{ width: "15vw", maxWidth: 188 }}>
                  <Option value="折扣(rebate)">折扣(rebate)</Option>
                  <Option value="破包">破包</Option>
                  <Option value="行銷費">行銷費</Option>
                  <Option value="預付金">預付金</Option>
                  <Option value="其他">其他</Option>
                </Select>
              </Form.Item>
              <Dash> –</Dash>
              <Form.Item name="nameOption" rules={[{ max: 40, message: "" }]}>
                <Input style={{ width: "210px" }} placeholder="項目細節，最多輸入 40 字元" />
              </Form.Item>
            </RowContent>
          </Row>
          <Row wrap={false}>
            <RowTitle>項目比例</RowTitle>
            <RowContent width={400}>
              <Form.Item
                name="rate"
                validateStatus={warningText ? "error" : "validating"}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value && getFieldValue("amount")) {
                        setWarningText("項目比例或項目金額(TWD) 只能填寫一項");
                        return Promise.reject(new Error(" "));
                      }
                      setWarningText(undefined);
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input />
              </Form.Item>
              <Percent>%</Percent>
            </RowContent>
          </Row>
          <Row wrap={false}>
            <RowTitle>項目金額(TWD)</RowTitle>
            <RowContent width={400}>
              <Form.Item
                name="amount"
                validateStatus={warningText ? "error" : "validating"}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value && getFieldValue("rate")) {
                        setWarningText("項目比例或項目金額(TWD) 只能填寫一項");
                        return Promise.reject(new Error(" "));
                      }
                      setWarningText(undefined);
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input />
              </Form.Item>
            </RowContent>
          </Row>
          <Row justify="end">
            <CustomButton onClick={onClose}>取消</CustomButton>
            <Button type="primary" htmlType="submit">
              確定
            </Button>
          </Row>
        </Form>
        {warningText && <p style={{ color: "red" }}>{warningText}</p>}
      </Wrapper>
    </PopupBackground>
  );
}
